import React from 'react';

import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import {hasAuth} from "../../../utils/NHCore";
import { Button } from 'antd';

import css from './index.css';
import numeral from 'numeral';

class ZytztjComponent extends React.Component {


    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('专业调整统计');
    }

    render() {

        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'row_id',
                fixed: 'left'
            }, {
                title: '年度',
                width: '80px',
                dataIndex: 'ND',
                key: 'nd',
                fixed: 'left',
                searchType:"select",
                defaultSearch: false
            }, {
                title: '学院名称',
                width: '120px',
                dataIndex: 'BMMC',
                key: 'bmmc',
                searchType:"select"
            }, {
                title: '专业名称',
                width: '120px',
                dataIndex: 'ZYMC',
                key: 'zymc',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '录取人数',
                width: '80px',
                dataIndex: 'LQRS',
                key: 'lqrs',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '报到人数',
                width: '80px',
                dataIndex: 'BDRS',
                key: 'bdrs',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '报到率',
                width: '80px',
                dataIndex: 'BDL',
                commonSearch: false,
                render: (value) => {
                    return numeral(value * 100).format("0.00") + '%';
                },
                searchType:"input"
            },
            {
                title: '转出人数',
                width: '80px',
                dataIndex: 'ZCRS',
                key: 'zcrs',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '转入人数',
                width: '80px',
                dataIndex: 'ZRRS',
                key: 'zrrs',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '实际人数',
                width: '80px',
                dataIndex: 'SJRS',
                key: 'sjrs',
                commonSearch: false,
                searchType:"input"
            }
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 220}}>
                <div style={{width: '100%', height: '90%',}}>
                    <NHTable ref='nhTable'
                             sign={"zhxg_yxxt_zytztj_querypage"}
                             columns={columns}
                             checkbox={false}>
                        <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button>
                    </NHTable>
                </div>
            </div>
        )
    }

}

export default ZytztjComponent;


// WEBPACK FOOTER //
// ./components/tjcx/zytzxx/zytztj.js